export enum ProductImportStateValues {
  MS_IDLE = 'MS_IDLE',
  MS_DATA_READY = 'MS_DATA_READY',
  MS_RUNNING_IMPORT = 'MS_RUNNING_IMPORT',
  MS_ERROR_DURING_IMPORT = 'MS_ERROR_DURING_IMPORT',
}

export interface ProductImportState {
  state: ProductImportStateValues;
  comment: string;
  updatedBy: string;
  updatedAt: Date;
}

export interface ProductImportStateForUpdate {
  state: ProductImportStateValues;
  comment: string;
  updatedByHint: string;
}
